<template>
    <div class="content">
		<el-alert title="售后原因" type="warning" show-icon :closable="false">以下仅支持配置申请取消商品和申请退货的原因，发货前修改收货地址无需配置原因</el-alert>
        <el-tabs v-model="activeName"  @tab-click="clickTab" class="MT20">
            <el-tab-pane label="发货前 - 申请取消商品" name="1"></el-tab-pane>
            <el-tab-pane label="发货后 - 申请退货" name="2"></el-tab-pane>
        </el-tabs>
		<div class="page-list-box" v-if="activeName == 1">
			<div class="page-btns-box">
			    <el-button v-if="$utils.have('/goodsAfterSale/reason/save')" type="primary"  size="small" @click="Add(0)">增加原因</el-button>
			</div>
			<!-- <vuedraggable v-model="dataList">
		    <el-table
		        :data="dataList"
		        border
		        style="width: 100%"
		        v-loading="listLoading"
		        size="small"
		        stripe
		    >
				
		        <el-table-column prop="reason" label="原因（原因支持拖动排序）" show-overflow-tooltip min-width="300"></el-table-column>
		        <el-table-column prop="isPhoto" label="上传照片">
					<template slot-scope="scope">
						 <span v-if="scope.row.isPhoto==0" >选择上传</span>
						 <span v-else-if="scope.row.isPhoto==1">必须上传</span>
					</template>	
				</el-table-column>
		        <el-table-column fixed="right" label="操作" width="150">
		            <template slot-scope="scope">
		                <el-button
		                    v-if="$utils.have('/goodsAfterSale/reason/delete')"
		                    type="text"
		                    size="small"
		                    icon="el-icon-delete"
		                    @click="del(scope.row.id,0)"
		                    >删除</el-button>		               
		            </template>    
		        </el-table-column>
		    </el-table>
			</vuedraggable> -->
			<div  style="overflow: auto;">
			    <table ref="table" border="0" class="draggable-table">
			        <thead>
			            <tr>
			                <th>
			                    <div class="cell">排序</div>
			                </th>
							
			                <th>
			                    <div class="cell">原因</div>
			                </th>
			                <th>
			                    <div class="cell">上传照片</div>
			                </th>			               
			                <th>
			                    <div class="cell">操作</div>
			                </th>
			            </tr>
			        </thead>
			        <vuedraggable v-model="dataList"  tag="tbody" handle=".handle"  @change="updateWordSort(0)">                
			            <template v-if="dataList && dataList.length > 0">
			                <tr v-for="t in dataList" :key="t.id">
			                    <td>
			                        <div class="cell handle">                                
			                            <i class="el-icon-sort"></i>
			                        </div>
			                    </td>
			                   
			                    <td>
			                        <div class="cell">
			                            {{t.reason}}
			                        </div>
			                    </td>
			                    <td>
			                        <div class="cell">
			                            <el-tag size="mini" :type="t.isPhoto == 1 ? 'danger' : 'success'">{{ t.isPhoto == 1 ?  "必须上传" : "选择上传"}}</el-tag>
			                        </div>
			                    </td>			                   
			                    <td>
			                        <div class="cell"> 
			                            <el-button
			                                type="text"
			                                size="small"
			                                icon="el-icon-s-management"
			                                @click="del(t.id,0)"
			                                v-if="$utils.have('/goodsAfterSale/reason/delete')"
			                                >删除</el-button>
			                        </div>
			                    </td>
			                </tr>
			            </template>
			            <tr v-else class="ignore">
			                <td colspan="9">
			                    <div class="empty">暂无数据</div>
			                </td>
			            </tr>
			        </vuedraggable>
			    </table>
			</div>
		</div>
		<div class="page-list-box" v-if="activeName == 2">
			<div class="page-btns-box">
			    <el-button v-if="$utils.have('/goodsAfterSale/reason/save')" type="primary"  size="small" @click="Add(1)">增加原因</el-button>
			</div>
		    <div  style="overflow: auto;">
		        <table ref="table" border="0" class="draggable-table">
		            <thead>
		                <tr>
		                    <th>
		                        <div class="cell">排序</div>
		                    </th>
		    				
		                    <th>
		                        <div class="cell">原因</div>
		                    </th>
		                    <th>
		                        <div class="cell">上传照片</div>
		                    </th>			               
		                    <th>
		                        <div class="cell">操作</div>
		                    </th>
		                </tr>
		            </thead>
		            <vuedraggable v-model="dataList2"  tag="tbody" handle=".handle"  @change="updateWordSort(1)">                
		                <template v-if="dataList2 && dataList2.length > 0">
		                    <tr v-for="t in dataList2" :key="t.id">
		                        <td>
		                            <div class="cell handle">                                
		                                <i class="el-icon-sort"></i>
		                            </div>
		                        </td>
		                        <td>
		                            <div class="cell">
		                                {{t.reason}}
		                            </div>
		                        </td>
		                        <td>
		                            <div class="cell">
		                                <el-tag size="mini" :type="t.isPhoto == 1 ? 'danger' : 'success'">{{ t.isPhoto == 1 ?  "必须上传" : "选择上传"}}</el-tag>
		                            </div>
		                        </td>			                   
		                        <td>
		                            <div class="cell"> 
		                                <el-button
		                                    type="text"
		                                    size="small"
		                                    icon="el-icon-s-management"
		                                    @click="del(t.id,1)"
		                                    v-if="$utils.have('/goodsAfterSale/reason/delete')"
		                                    >删除</el-button>
		                            </div>
		                        </td>
		                    </tr>
		                </template>
		                <tr v-else class="ignore">
		                    <td colspan="9">
		                        <div class="empty">暂无数据</div>
		                    </td>
		                </tr>
		            </vuedraggable>
		        </table>
		    </div>
		</div>
		<Add ref="Add" @onUpdate="onUpdateList" @callBack="callBack"></Add>
    </div>
</template>

<script>
import Add from './components/add';
import vuedraggable from 'vuedraggable';
export default {
    components:{Add,vuedraggable},
    data(){
        return{
            activeName: "1",
			listLoading:false,
			dataList: null,
			dataList2:null
        }
    },
    computed:{
        
    },
    mounted() {
        this.getDataList(0)
    },
    methods:{
       //获取列表
       getDataList(type) {           
           this.listLoading = true;
           this.$request({
               url: "/goodsAfterSale/reason/list",
               method: "POST",
               params: {
					type:type              
               },
           })
               .then((res) => {
                   const { state, msg, result } = res.data;
                   if (state == 1 && result) {
					   if( type == 0 ){
						   this.dataList = result || [];
						   this.listLoading = true
					   }else{
						   this.dataList2 = result || [];
						   this.listLoading = true
					   }
                       
                   } else {
                       this.$message.error(msg || "请求失败");
                   }
               })
               .catch(() => {
                   this.$message.error("请求错误");
               })
               .finally(() => {
                  this.listLoading = false;
               });
       },
       clickTab(tab){
		   if( tab.name == 1 ){
			this.getDataList(0);   
		   }else{
			this.getDataList(1);  
		   }           
       },
	   callBack( type ){
		   if( type == 0){
			   this.activeName == 1
		   }else{
			   this.activeName == 2
		   }
	   },
	   async onUpdateList(type){
	       const obj = type;
	       if( obj == 0 ){
				this.getDataList(0);   
	       }else{
	       		this.getDataList(1);  
	       }   
	   },
       del(id,type){
		   
		  this.$confirm('删除该原因后，用户将无法选择该售后?', '提示', {
		      confirmButtonText: '确认删除',
		      cancelButtonText: '取消',
		      type: 'warning',
		      center: true,
		      closeOnClickModal: false
		  }).then(()=> {
		      this.$request({
		          url: "/goodsAfterSale/reason/delete",
		          method: "POST",
		          params:{
		              id:id
		          }
		      }).then(res=> {
		          const { state, msg } = res.data;
		          if (state && state == 1 ) {
		              this.$message.success("删除成功");
					  if( type == 0 ){
						this.getDataList(0)
						this.activeName == 1
					  }else{
						this.getDataList(1)
						this.activeName == 2  
					  }
		              
		          } else {
		              return this.$message.error(msg || "删除失败");
		          }
		      })
		  }).catch(()=> {})  
	   },
	   Add(type){
	       this.$refs.Add.show(type);
	   },
	   updateWordSort(type){
		   var data = {}
		   if( type == 0 ){
			  data = this.dataList.map((i, idx)=>{
			      i.sort = idx + 1;          
			      return {
			          sort: i.sort,
			          id: i.id
			      }
			  }) 
		   }else{
				data = this.dataList2.map((i, idx)=>{
			       i.sort = idx + 1;          
			       return {
			           sort: i.sort,
			           id: i.id
			       }
			   })
		   }	       
	       this.$request({
	           url: "/goodsAfterSale/reason/sort",
	           method: "POST",
	           data
	       }).then((res) => {
	               const { state, msg } = res.data;
	               if (state == 1 ) {
	                   this.$message.success("操作成功");
					    if( type == 0 ){
							this.getDataList(0);   
						}else{
							this.getDataList(1);   
						}
	               } else {
	                   this.$message.error(msg || "请求失败");
	               }
	           })
	           .catch(() => {
	               this.$message.error("请求错误");
	           })
	   },
       
    }
}
</script>
<style lang="scss" scoped>
.draggable-table {
    table-layout: auto;
    border-collapse: collapse;
    width: 100%;
    min-width: 710px;
    border: 1px solid #ebeef5;

    .empty {
        text-align: center;
        line-height: 20px;
        color: #909399;
    }

    th,
    td {
        position: relative;
        padding: 10px 0;
        text-align: left;
        border: 1px solid #ebeef5;
        border-top: 0;
        border-left: 0;
        vertical-align: middle;
        box-sizing: border-box;

        .cell {
            padding: 0 10px;
            width: 100%;
            white-space: normal;
            word-break: break-all;
            line-height: 23px;
            overflow: hidden;
            box-sizing: border-box;

            &.handle {
                cursor: move;
            }
        }
    }

    th {
        background-color: #f5f7fa;
        font-size: 13px;
        color: #909399;
        font-weight: 700;
        .cell{
            white-space: nowrap;
        }
    }

    td {
        font-size: 13px;
        color: #606266;
    }

    tr:hover td {
        background-color: #f5f7fa;
    }
}
</style>sss